/**
 * Facebook's, Instagram's and Messenger's in-app browsers, where every paid
 * visitor arrives, by the tags they put in the user agent. Pure, so the unit
 * suite (node, no DOM) can hold it to real user agents.
 *
 * Read for the `in_app` property on the email events (lib/contact.ts). A link
 * tapped in Mail opens in Safari, a different browser with different storage;
 * the handoff code it carries is what makes that the same person (lib/handoff.ts).
 */
export function inAppBrowser(ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): 'facebook' | 'instagram' | 'messenger' | null {
  if (/\bInstagram\b/i.test(ua)) return 'instagram';
  if (/FBAN\/Messenger|MessengerForiOS|MessengerLite/i.test(ua)) return 'messenger';
  if (/FB_IAB|FBAN\/|FBAV\/|FBIOS/i.test(ua)) return 'facebook';
  return null;
}

/** Good enough to catch a slip of the thumb; the mail server is the real check. */
export function looksLikeEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s.trim());
}
